import { useEffect, useRef } from 'react';
import { Box, Fade, styled } from '@mui/material';

import useScrollTo from '../../hooks/useScrollTo';

export interface PageLayoutProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  topBanner?: React.ReactNode;
}

const StyledBox = styled(Box)`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const HeaderContainer = styled(Box)<{ sticky?: string }>(
  ({ theme }) => `
  color: ${theme.partner.header.color};
  background-color: ${theme.partner.header.backgroundColor};
  position: sticky; 
  top: 0; 
  z-index: ${theme.zIndex.appBar};
  `,
);

const ExpandedHeightBox = styled(Box)`
  flex: 1 1 auto;
`;

const PageLayout: React.FC<PageLayoutProps> = ({ children, header, footer, topBanner }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const { scrollTo } = useScrollTo().actions;
  useEffect(() => {
    scrollTo('top', { behavior: 'auto' });
  }, []);

  return (
    <Fade in>
      <StyledBox ref={scrollRef}>
        <HeaderContainer id="page-layout-header-container">
          {topBanner}
          {header}
        </HeaderContainer>
        <ExpandedHeightBox>{children}</ExpandedHeightBox>
        {footer}
      </StyledBox>
    </Fade>
  );
};

export default PageLayout;
